/**
 * Created by Artur on 2017-04-10.
 */


(function (angular) {
    angular
        .module('repairforms.service.module')
        .service('WebService', WebService);

    WebService.$inject = ['RepairformsRequestService', '$q'];

    function WebService(RepairformsRequestService, $q) {
        return {
            getFirstPartOfLink : getFirstPartOfLink
        };

        function getFirstPartOfLink() {

            var deferred = $q.defer();

            $q.all([
                getCountry(),
                getLanguage()
            ]).then(function (countryAndLanguage) {
                deferred.resolve(returnLink(countryAndLanguage));
            }).catch(function (err) {
                deferred.reject(err);
            });

            return deferred.promise;

        }

        function getCountry() {
            var deferred = $q.defer();

            RepairformsRequestService.getCountry().then(function successCallback(response) {
                deferred.resolve(response.data.country);
            }, function errorCallback(response) {
                deferred.resolve('');
            });

            return deferred.promise;
        }

        function getLanguage() {
            var deferred = $q.defer();

            RepairformsRequestService.getLanguage().then(function successCallback(response) {
                deferred.resolve(response.data.language);
            }, function errorCallback(response) {
                deferred.resolve('');
            });

            return deferred.promise;
        }

        function returnLink(countryAndLanguage) {

            var country = 0;
            var language = 1;

            if (countryAndLanguage[language] === 'pl') {
                return 'https://www.bosch-professional.com/pl/media/country_content/service/after_sales_service/online_repair_service/repairform/';
            }

            if (countryAndLanguage[country] === 'it') {
                return 'https://www.bosch-professional.com/it/media/italy/repairform/';
            }

            return "https://www.bosch-professional.com/"
                + countryAndLanguage[country]
                + "/media/"
                + countryAndLanguage[language]
                + returnRepairformPartOfLink(countryAndLanguage[country], countryAndLanguage[language]) ;
        }

        function returnRepairformPartOfLink (country, language) {
            if(language === 'de' || language === 'en' || (language === 'nl' && country === 'nl') || (language === 'fr' && country === 'be')){
                return "/repairform/";
            } else {
                return  "/repairform_" + language + "/";
            }
        }

    };

})(angular);
